module.exports = __webpack_public_path__ + "static/media/Header.a7a2c75a.png";